import { Card } from '../types'

export function CalculateSum(hand: Card[]): number {
  // multiply all cards if we have a multiplier card in hand
  function multi(amount: number): number {
    const idx = hand.findIndex((card) => card === 'x2')
    if (idx > -1) {
      return amount * 2
    }

    return amount
  }

  return hand.reduce((total: number, card) => {
    if (!isNaN(Number(card))) {
      return total + multi(card as number)
    }

    // figure out what the modifier card does...
    if (card.toString().startsWith('a')) {
      const mod = Number(card.toString().slice(1))
      return total + mod
    }

    return total
  }, 0)
}
